import React, { Component } from 'react';
import Config from './Configs/criteria.json';
import './ResultListTable.css'
import pdficon from './img/pdf_icon.svg';
import videoicon from './img/open_video_icon.svg'
import researchicon from './img/research_icon.svg'


const periodList = ["通期", "1Q", "2Q", "3Q", "4Q"]
export default class ResultListTable extends Component {
    constructor(props) {
        super(props);

        this.state = { surprise_rating: "", openResearchMenu:""};
        this.surprise_rating = ""
    }
    getTotalNumOfCriteriaSelected = () => {
        let cnt = 0;
        Object.keys(Config.criteria.advanced).forEach((key) => {
            for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                if (this.props.criteria.advanced[key][i].selected) {
                    cnt++;
                }
            }
        });
        return cnt;
    }
    getTotalNumOfCriteriaEnbaled = () => {
        let cnt = 0;
        Object.keys(Config.criteria.advanced).forEach((key) => {
            for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                if (this.props.criteria.advanced[key][i].selected && this.props.criteria.advanced[key][i].enabled) {
                    cnt++;
                }
            }
        });
        return cnt;
    }
    generateAdvCriteriaTitleRow = () => {
        let result = [];
        let cnt = 0;
        this.surprise_rating = ""
        for (let n = 0; n < this.props.advancedQueue.length; n++) {
            let key = this.props.advancedQueue[n].key;
            let i = this.props.advancedQueue[n].i;
            // Object.keys(Config.criteria.advanced).forEach((key) => {
            // for (let i=0; i<Config.criteria.advanced[key].length; i++) {
            if (this.props.criteria.advanced[key][i].selected && this.props.criteria.advanced[key][i].enabled) {
                if (Config.criteria.advanced[key][i].id === "surprise_rating") {
                    result.push(<th style={{ wordBreak: "keep-all" }} key={"a" + cnt} >発表日<i className={this.props.sortby === ("a" + cnt) ? (this.props.sortorder === "asc" ? "sort-by-asc" : "sort-by-desc") : ""}></i></th>);
                    result.push(<td style={{ wordBreak: "keep-all" }} >種別</td>)
                    result.push(<td >乖離率</td>)
                    result.push(<td >{Config.criteria.advanced[key][i].options[this.props.criteria.advanced[key][i].option]}<br />（実績）</td>)
                    result.push(<td style={{ wordBreak: "keep-all" }}>{Config.criteria.advanced[key][i].options[this.props.criteria.advanced[key][i].option]}<br />（コンセンサス）</td>)
                    this.surprise_rating = "_surprise_rating"
                } else {
                    result.push(<th key={"a" + cnt} onClick={this.handleSort("a" + cnt)} className={"a" + cnt + " sortable"}>{Config.criteria.advanced[key][i].name}<i className={this.props.sortby === ("a" + cnt) ? (this.props.sortorder === "asc" ? "sort-by-asc" : "sort-by-desc") : ""}></i></th>);
                }

                cnt++;
            }
            // }
            // });
        }
        if (cnt < 5) {
            for (let i = 0; i < (5 - cnt); i++) {
                result.push(<td key={"a" + (cnt + i)} className={"a" + (cnt + i)}></td>)
            }
        }
        return result;
    }
    generateAdvCriteriaDataColumn = (rownum) => {
        let result = [];
        let cnt = 0;
        for (let n = 0; n < this.props.advancedQueue.length; n++) {
            let key = this.props.advancedQueue[n].key;
            let i = this.props.advancedQueue[n].i;
            // Object.keys(Config.criteria.advanced).forEach((key) => {
            // for (let i=0; i<Config.criteria.advanced[key].length; i++) {
            if (this.props.criteria.advanced[key][i].selected && this.props.criteria.advanced[key][i].enabled) {
                if (Config.criteria.advanced[key][i].id === "surprise_rating") {
                    result.push(<td class="s1" >{this.props.data[rownum].s.announceDate}</td>);
                    let star = "";
                    for (let x = 0; x < this.props.data[rownum].s.rating; x++) {
                        star += "★";
                    }
                    let period = this.props.data[rownum].s.period;
                    if (period === "-1") period = 0;
                    result.push(<td class="s1" style={{ wordBreak: "keep-all" }}>{periodList[period]}</td>);
                    result.push(<td class="s1" style={{ textAlign: 'center' }} >{Number.parseFloat(this.props.data[rownum].s.surprise).toFixed(1)}%<br />{star}</td>);
                    result.push(<td class="s1" >{Number.parseFloat(this.props.data[rownum].s.actual).toFixed(1)}</td>);
                    result.push(<td class="s1" >{Number.parseFloat(this.props.data[rownum].s.consensus).toFixed(1)}</td>);
                } else {
                    result.push(<td className={this.props.sortby === ("a" + cnt) ? ("a" + cnt + " sort") : ("a" + cnt)} key={"a" + cnt + "_" + this.props.data[rownum].ric}>{this.props.data[rownum]["a" + cnt]}</td>);

                }
                cnt++;
            }
            // }
            // });
        }
        if (cnt < 5) {
            for (let i = 0; i < (5 - cnt); i++) {
                result.push(<td className={this.props.sortby === ("a" + (cnt + i)) ? ("a" + (cnt + i) + " sort") : ("a" + (cnt + i))} key={"a" + (cnt + i) + "_" + this.props.data[rownum].ric}></td>)
            }
        }
        return result;
    }
    generateResultList = () => {
        let result = [];
        let cnt = 0;
        if (this.props.data) {
            for (let i = 0; i < this.props.data.length; i++) {
                let item = [];
                let tmpUrl = this.props.appId === "Hyper" ? Config.hyperdomain + "/1004/" + this.props.data[i].ec + "/" + this.props.data[i].c : Config.domain + "/ETGate/?_ControlID=WPLETsiR001Control&_PageID=WPLETsiR001Idtl10&_DataStoreID=DSWPLETsiR001Control&_ActionID=stockDetail&stock_sec_code_mul=" + this.props.data[i].c + "&exchange_code=" + this.props.data[i].ec + "&i_dom_flg=1&i_output_type=0&getFlg=on&OutSide=on&"
                item.push(this.generateAdvCriteriaDataColumn(i));
                item.push(<td className="b" key={"b_" + this.props.data[i].ric}><div className="addto" onClick={this.handleAddTo(this.props.data[i].c, this.props.data[i].ec, this.props.data[i].rec)}>追加</div></td>);
                result.push(<tr key={this.props.data[i].ric}>{item}</tr>);
                cnt++;
            }
        }
        if (cnt < this.props.recperpage) {

            for (let i = 0; i < this.props.recperpage - cnt; i++) {
                let item = [];
                let surpriseSelected = (this.props.criteria.advanced["consensus"][28].selected && this.props.criteria.advanced["consensus"][28].enabled);
                for (let j = 0; j < (this.getTotalNumOfCriteriaSelected() < 5 ? 5 : this.getTotalNumOfCriteriaSelected()); j++) {

                    item.push(<td className={this.props.sortby === ("a" + j) ? ("a" + j + " sort") : ("a" + j)} key={"a" + j + "_" + (cnt + i + 1)}></td>)

                }
                if (surpriseSelected && this.surprise_rating !== "") {
                    item.push(<td className="s1"></td>)
                    item.push(<td className="s1"></td>)
                    item.push(<td className="s1"></td>)
                    item.push(<td className="s1"></td>)
                    surpriseSelected = false;
                }
                item.push(<td className="b" key={"b_" + (cnt + i + 1)}></td>);
                result.push(<tr key={"row_" + (cnt + i + 1)}>{item}</tr>);
            }
        }
        return result;
    }
    onClickResearchIcon = (ric) => {
        console.log(`this.state.openResearchMenu`,this.state.openResearchMenu,ric)
        if(this.state.openResearchMenu===ric){
            this.setState({openResearchMenu:""})
        }else{
            this.setState({openResearchMenu:ric})
        }
    }
    generateResultListLeft = () => {
        let result = [];
        let cnt = 0;
        if (this.props.data) {
            for (let i = 0; i < this.props.data.length; i++) {
                let item = [];
                let isOpen = false
                let tmpUrl = this.props.appId === "Hyper" ? Config.hyperdomain + "/1004/" + this.props.data[i].ec + "/" + this.props.data[i].c : Config.domain + "/ETGate/?_ControlID=WPLETsiR001Control&_PageID=WPLETsiR001Idtl10&_DataStoreID=DSWPLETsiR001Control&_ActionID=stockDetail&stock_sec_code_mul=" + this.props.data[i].c + "&exchange_code=" + this.props.data[i].ec + "&i_dom_flg=1&i_output_type=0&getFlg=on&OutSide=on&"
                let videoUrl = "/sbivideo/video?vid=<vid>&sbi_setting=2000000&mode=pc&token="+this.props.token;
                item.push(<td className={this.props.sortby === "c" ? "c sort fixedtable" : "c fixedtable"} key={"c_" + this.props.data[i].ric}>{this.props.data[i].c}</td>);
                item.push(<td className="n fixedtable" key={"n_" + this.props.data[i].ric}>
                    <div className="ndiv" >
                        <div><a href={tmpUrl} rel="noopener noreferrer" target={this.props.appId === "Hyper" ? "_self" : "_blank"}>{this.props.data[i].n}</a></div>
                        {/* <div className="ndivpdficon">{this.props.data[i].srplus_link && <a rel="noopener noreferrer" target="_blank" href={this.props.data[i].srplus_link}><img src={pdficon} width="20" height="25" alt="srplus" /></a>}</div> */}
                        {(!this.props.data[i].vid&&this.props.data[i].srplus_link)&&<div className="ndivpdficon" onClick={()=>{this.props.data[i].srplus_link&&fetch("/sbiscrapi/srpluslog?app="+(this.props.appId === "Hyper"?"hyper":"pc")+"&ric="+ this.props.data[i].ric)}}>{this.props.data[i].srplus_link && <a rel="noopener noreferrer" target={this.props.appId === "Hyper" ? "_self" : "_blank"} href={this.props.appId === "Hyper"?this.props.data[i].srplus_link.replace("https","hyper"):this.props.data[i].srplus_link}><img src={pdficon} width="20" height="25" alt="srplus" /></a>}</div>}
                        {(this.props.data[i].vid && !this.props.data[i].srplus_link)&&<div className="ndivpdficon" >{this.props.data[i].vid && <a rel="noopener noreferrer" target={this.props.appId === "Hyper" ? "_self" : "_blank"} href={this.props.appId === "Hyper"?videoUrl.replace("<vid>",this.props.data[i].vid).replace("https","hyper"):videoUrl.replace("<vid>",this.props.data[i].vid)}><img src={videoicon} width="20" height="25" alt="videoicon" /></a>}</div>}
                        {(this.props.data[i].vid&&this.props.data[i].srplus_link)&&
                        <div className="researchicondiv" onClick={()=>{this.onClickResearchIcon(this.props.data[i].ric)}} >
                            <img className="researchicon" width="20" height="25" src={researchicon} alt="researchicon" />
                            <div className={`tooltipicondiv ${this.state.openResearchMenu===this.props.data[i].ric&&"selected"}`}>
                                <div className="tooltipiconcol" onClick={()=>{this.props.data[i].srplus_link&&fetch("/sbiscrapi/srpluslog?app="+(this.props.appId === "Hyper"?"hyper":"pc")+"&ric="+ this.props.data[i].ric)}}>{this.props.data[i].srplus_link && <a rel="noopener noreferrer" target={this.props.appId === "Hyper" ? "_self" : "_blank"} href={this.props.appId === "Hyper"?this.props.data[i].srplus_link.replace("https","hyper"):this.props.data[i].srplus_link}><span className="pdficonspan">レポート</span><img src={pdficon} width="20" height="25" alt="srplus" /></a>}</div>
                                <div className="tooltipiconcol" >{this.props.data[i].vid && <a rel="noopener noreferrer" target={this.props.appId === "Hyper" ? "_self" : "_blank"} href={this.props.appId === "Hyper"?videoUrl.replace("<vid>",this.props.data[i].vid).replace("https","hyper"):videoUrl.replace("<vid>",this.props.data[i].vid)}><span className="videoiconspan">ショート動画</span><img src={videoicon} width="20" height="25" alt="videoicon" /></a>}</div>
                            </div>
                        </div>}
                        {/*{<div className="tooltipicondiv">
                            <img className="tooltipicon" src={tooltipicon} alt="tooltipicon" />
                        </div>*/}
                        
                    </div>
                </td>);
                item.push(<td className="m fixedtable" key={"m_" + this.props.data[i].ric}>{this.props.data[i].e}</td>);
                item.push(<td className="l fixedtable" key={"l_" + this.props.data[i].ric}>{this.formatNumber(this.props.data[i].l, this.props.data[i].ldp)}<br /><span className={parseFloat(this.props.data[i].h.replace(/,/g, '')) > 0 ? "positive" : (parseFloat(this.props.data[i].h.replace(/,/g, '')) < 0 ? "negative" : "")}>{(parseFloat(this.props.data[i].l) === 0) ? "- (-%)" : (this.props.data[i].h + " (" + this.props.data[i].p + "%)")}</span></td>);
                result.push(<tr key={this.props.data[i].ric}>{item}</tr>);
                cnt++;
            }
        }
        if (cnt < this.props.recperpage) {
            for (let i = 0; i < this.props.recperpage - cnt; i++) {
                let item = [];
                item.push(<td className={this.props.sortby === "c" ? "c sort fixedtable" : "c fixedtable"} key={"c_" + (cnt + i + 1)}></td>);
                item.push(<td className="n fixedtable" key={"n_" + (cnt + i + 1)}></td>);
                item.push(<td className="m fixedtable" key={"m_" + (cnt + i + 1)}></td>);
                item.push(<td className="l fixedtable" key={"l_" + (cnt + i + 1)}></td>);
                result.push(<tr key={"lrow_" + (cnt + i + 1)}>{item}</tr>);
            }
        }
        return result;
    }
    handleSort = (col) => (e) => {
        this.props.onSort(col);
    }
    handleAddTo = (code, exchangeCode, rexchangeCode) => (e) => {
        let url = this.props.appId === "Hyper" ? Config.hyperdomain + "/5907/" + rexchangeCode + "/" + code : Config.domain + "/ETGate/?_ControlID=WPLETpfR001Control&_PageID=WPLETpfR001Eins13&_DataStoreID=DSWPLETpfR001Control&getFlg=on&_ActionID=viewPf&src_web_sec_code=" + code + "&src_sec_id=ST&src_market_id=" + rexchangeCode + "&link_url=%2FETGate%2F%3F_ControlID%3DWPLETsqR001Control%26amp%3B_DataStoreID%3DDSWPLETsqR001Control%26amp%3B_PageID%3DWPLETsqR001Sdtl10%26amp%3BgetFlg%3Don%26amp%3B_ActionID%3DDefaultAID%26amp%3Bi_stock_sec%3D4307%26amp%3Bcat1%3Ddomestic%26amp%3Bcat2%3Dinfo%26amp%3Bsec_code%3D4307%26amp%3Bexchange_code%3D" + exchangeCode + "%26amp%3Bi_exchange_code%3DJPN&OutSide=on";
        window.open(url, this.props.appId === "Hyper" ? "_self" : "_blank");
    }
    formatNumber = (val, dp) => {
        // console.log("val:");
        // console.log(val);
        if (val && parseFloat(val) !== 0) {
            if (typeof val !== 'number') {
                val = parseFloat(val.replace(/,/g, ''));
            }

            if (dp) {
                val = new Intl.NumberFormat('en-GB', {
                    minimumFractionDigits: dp,
                    maximumFractionDigits: dp
                }).format(val);
            } else {
                val = new Intl.NumberFormat('en-GB').format(val);
            }
            return val;
        } else {
            return '-';
        }
    }
    componentDidUpdate() {
    }
    render() {
        return (
            <div className="ResultListTable">
                <div className="ResultListMainDiv">
                    {/* <div className="topscroll"></div> */}
                    <div className="lock_box">
                        <table className="leftTable">
                            <tbody>
                                <tr className="th">
                                    <th onClick={this.handleSort("c")} className="c sortable fixedtable">コード<i className={this.props.sortby === "c" ? (this.props.sortorder === "asc" ? "sort-by-asc" : "sort-by-desc") : ""}></i></th>
                                    <th className="n fixedtable">銘柄名</th>
                                    <th className="m fixedtable">市場</th>
                                    <th className="l fixedtable">現在値<br />前日比(%)</th>
                                </tr>
                                {
                                    this.generateResultListLeft()
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="x_auto_box">
                        <table className={"rightTable t" + this.getTotalNumOfCriteriaEnbaled() + this.surprise_rating}>
                            <tbody>
                                <tr className="th">
                                    {
                                        this.generateAdvCriteriaTitleRow()
                                    }
                                    <th className="b">ポートフォリオ</th>
                                </tr>
                                {
                                    this.generateResultList()
                                }
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        );
    }
}